// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".oa-check-confirm-poper {\n  padding-bottom: 12px;\n  width: 340px;\n}\n.oa-check-confirm-poper .el-message-box__header {\n    padding-top: 18px;\n}\n.oa-check-confirm-poper .el-message-box__btns button {\n    width: 88px;\n}\n.oa-check-confirm-poper .el-button.el-button--primary.el-button--small {\n    color: #FFFFFF;\n}\n", ""]);
// Exports
module.exports = exports;
